//@sample-repo
import Vue from 'vue'

const url = Vue.prototype.$config.api_url + Vue.prototype.$config.resources.payment

const profile = {
  create(payload:any) {
    const Url = Vue.prototype.$config.api_url + Vue.prototype.$config.resources.payment_request
    return Vue.prototype.$httpService.post(Url,payload)
  },
  partial_edit(code:string|number,payload:any) {
    let Url= url.replace("{0}",code)
    return Vue.prototype.$httpService
    .put(Url, payload)
  },
  find(id:string|number, systemType:string) {
    let URL = url + `/${id}?system=${systemType}`
    return Vue.prototype.$httpService
    .get(URL)
  },
  delete(code:string|number,id:string|number) {
    let Url= url.replace("{0}",code)
    return Vue.prototype.$httpService.delete(Url +`/${id}`)
  },
  list(code:any=null) {
    let Url= url+ `?term_state_code=${code}`
    return Vue.prototype.$httpService.get(Url)
  }
}

export default profile;

